import React, { useState, createElement } from 'react'
import ReactDom from 'react-dom'
import { Button, Modal, Form, Radio } from 'tea-component';
import { MessageDescriptor } from 'react-intl';

enum timeScaleOptions {
  _5MIN = '5',
  _10MIN = '10',
  _60MIN = '60'
}
const { _5MIN, _10MIN, _60MIN } = timeScaleOptions;

type DownloadType = {
  value: string;
  title: string;
  titleCn: string;
  formatTitle: string;
  disabled: boolean;
}

interface DownloadConfigItem {
  title: string;
  titleCn: string;
  formatTitle: string;
  defaultValue: string;
  type: DownloadType[];
}

interface DownloadOptionsModalProps {
  onConfirm: (formValue: any) => void;
  onExited?: () => void;
  visible: boolean;
  downloadConfig: DownloadConfigItem[];
  isCN: boolean;
  formatMessage?: (message: MessageDescriptor) => string;
}

const DownloadOptionsModal: React.FC<DownloadOptionsModalProps> = (props) => {
  const { onConfirm, onExited, visible, downloadConfig, isCN } = props;

  const formatMessage = props.formatMessage || function (val: any) {
    return val.id;
  };

  const [showModal, setShowModal] = useState(visible || false);
  const [formValue, setFormValue] = useState<any>({
    timeScale: downloadConfig[0]?.defaultValue || _5MIN
  });

  const handleConfirm = () => {
    onConfirm && onConfirm(formValue);
    setShowModal(false);
  };

  return (
    <Modal
      visible={showModal}
      className={'download_setting_modal'}
      caption={formatMessage({ id: 'realtime_info_download_settings' })}
      onClose={() => setShowModal(false)}
      onExited={() => onExited && onExited()}
      maskClosable
    >
      <Modal.Body>
        <Form className={'download_setting_form'}>
          {downloadConfig.map((item: any, index: number) => (
            <Form.Item
              label={<span className='download-text'>{isCN ? item.titleCn : item.title}</span>}
              className={'download_setting_form_item'}
            >
              <Radio.Group 
                value={formValue.timeScale} 
                onChange={(val => setFormValue({ ...formValue, timeScale: val }))}>
                {item.type.map((subItem: any, subIndex: number) => {
                  return <Radio
                    key={subIndex}
                    name={subItem.value}
                    disabled={subItem.disabled}
                    // disabled={options.timeScale.disabled[subItem.value]}
                  >
                    {isCN ? subItem.titleCn : subItem.title}
                  </Radio>
                })}
              </Radio.Group>
            </Form.Item>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleConfirm}>
          {formatMessage({ id: 'menu_confirm' })}
        </Button>
        <Button type="weak" onClick={() => setShowModal(false)}>
          {formatMessage({ id: 'menu_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export const showDownloadSettings = (props: any): Promise<void> => {
  return new Promise(function (resolve) {
    var el = document.createElement("div");
    ReactDom.render(
      // @ts-ignore
      createElement(DownloadOptionsModal, {
        ...props,
        visible: true,
        onConfirm: function (val: any) {
          props.onConfirm && props.onConfirm(val);
          return resolve(val);
        },
        onExited: function () {
          props.onExited && props.onExited();
          ReactDom.unmountComponentAtNode(el);
        }
      })
      , el)
  })
}